<template>
  <div class="p-2">
    <custom-input-radio
      v-model="isPublic"
      label="File Permissions"
      :options="options"
      name="permissions"
      stacked="true"
      class="d-flex"
    />
    <div style="max-width:520px">
      <custom-alert
        icon-name="Info"
        items-center
      >
        If you set this option to public, this file will be accessible publicly.
      </custom-alert>
    </div>
    <div class="d-flex justify-content-end">
      <b-button
        variant="primary"
        :disabled="settingPermission || !touched"
        @click="setPermission"
      >
        Save
      </b-button>
    </div>
  </div>
</template>

<script>
import CustomInputRadio from '@/components/form/CustomInputRadio.vue'

export default {
  name: 'FilePermissions',
  components: { CustomInputRadio },
  props: {
    file: {
      type: Object,
      default: null,
      required: true,
    },
    accountId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      isPublic: false,
      options: [
        { text: 'Public', value: true },
        { text: 'Private', value: false },
      ],
      settingPermission: false,
    }
  },
  computed: {
    touched() {
      return this.file.isPublic !== this.isPublic
    },
  },
  created() {
    this.isPublic = this.file.isPublic
  },
  methods: {
    setPermission() {
      this.settingPermission = true
      this.$store.dispatch('accountObjects/updateObject', {
        accountId: this.accountId,
        query: {
          ...this.file,
          isPublic: this.isPublic,
        },
      }).then(() => {
        this.successToast('Permission updated successfully.')
        this.settingPermission = false
        this.$emit('refresh')
      }).catch(() => {
        this.errorToast('Error updating permission.')
        this.settingPermission = false
        this.isPublic = this.file.isPublic
      })
    },
  },

}
</script>

<style>

</style>
